// import { Link } from '@/i18n/routing';
// import Image from "next/image";
// import Social from "@/components/partials/auth/social";
// import Logo from "@/components/partials/auth/logo";

import Copyright from "../components/partials/auth/copyright";
import LoginForm from "../components/partials/auth/login-form";
import Logo from "../components/partials/auth/logo";
import { Link, Navigate } from "react-router-dom";
import { routes } from "router";
import { useAuth } from "context/auth-context";
import { loginBg1 } from "images";

export default function Login() {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? (
    <Navigate to={routes.Home.path} replace />
  ) : (
    <main>
      <div className="flex w-full items-center overflow-hidden min-h-dvh h-dvh basis-full">
        <div className="overflow-y-auto flex flex-wrap w-full h-dvh">
          <div
            className="lg:block hidden flex-1 overflow-hidden text-[40px] leading-[48px] tracking-tight text-default-700
                        relative z-[1] bg-accent"
          >
            <div className="max-w-[520px] pt-20 ps-20 ">
              <Link to={routes.Login.path} className="mb-6 inline-block">
                <Logo />
              </Link>
              <h4>
                Effortless Store Management
                <span className="text-default-900 font-semibold ms-2">
                  Performance
                </span>
              </h4>
            </div>
            <div className="absolute left-0 2xl:bottom-[-160px] bottom-[-130px] h-full w-full z-[-1]">
              <img
                src={loginBg1}
                alt=""
                width={300}
                height={300}
                className="mb-10 w-full h-full object-contain"
              />
            </div>
          </div>
          <div className="flex-1 relative">
            <div className=" h-full flex flex-col  bg-card">
              <div className="max-w-[524px] md:px-[42px] md:py-[44px] p-7  mx-auto w-full text-2xl text-default-900  mb-3 h-full flex flex-col justify-center">
                <div className="flex justify-center items-center text-center mb-6 lg:hidden ">
                  {/*<Link href="/">*/}
                  <Logo />
                  {/*</Link>*/}
                </div>
                <div className="text-center 2xl:mb-10 mb-4">
                  <h4 className="font-medium">Sign in</h4>
                  <div className="text-default-500 text-base">
                    Sign in to your account to start using Storbolt
                  </div>
                </div>
                <LoginForm />
                {/*<div className="relative border-b-[#9AA2AF] border-opacity-[16%] border-b pt-6">*/}
                {/*    <div*/}
                {/*        className="absolute inline-block bg-default-50 dark:bg-default-100 left-1/2 top-1/2 transform -translate-x-1/2 px-4 min-w-max text-sm text-default-500 font-normal">*/}
                {/*        Or continue with*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="max-w-[242px] mx-auto mt-8 w-full">
                  {/*<Social />*/}
                </div>
                <div className="md:max-w-[345px] mx-auto font-normal text-default-500 mt-12 uppercase text-sm">
                  Don’t have an account?{" "}
                  <Link
                    to={routes.SignUp.path}
                    className="text-default-900  font-medium hover:underline"
                  >
                    Sign Up
                  </Link>
                </div>
              </div>
              <div className="text-xs font-normal text-default-500  z-[999] pb-10 text-center">
                <Copyright />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
